import {createSelector} from 'reselect';

import {getAccountId} from '../../../../services/selectors';
import {parseContracts} from '../parse-contracts';

import type {ParseContracts} from '../parse-contracts';
import type {ContractsListDto} from '../typedef';
import type {AppState} from 'src/store/typedef';

export const getContractData = (state: AppState): {[key: number]: ContractsListDto | null} =>
    state.apiv2.contractsData.data;

export const contractsDataSelector = createSelector<
    AppState,
    number,
    {[key: number]: ContractsListDto | null},
    ParseContracts | null
>(
    getAccountId,
    getContractData,
    (accountId, data) => {
        const dataById = data[accountId] || null;
        return dataById ? parseContracts(dataById) : null;
    },
);

export const requiredContractsRefreshSelector = (state: AppState) => state.apiv2.contractsData.requiredRefresh;
